import { Grid, makeStyles } from '@material-ui/core';
import React, { useMemo } from 'react';
import { get } from 'lodash';
import { Dimensions, Weight } from 'icons';
import { convertGmToKgGm, convertOzToLbOz } from 'services/helpers/convertWeight';

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: 'bottom',
    color: theme.palette.primary.light,
    marginRight: theme.spacing(1),
  },

  params: {
    fontSize: 14,
    lineHeight: '24px',
    color: theme.palette.text.secondary,
  },
}));

const PackageField = ({ record = {} }) => {
  const classes = useStyles();

  const isOldShipment = !!get(record, 'weight');
  const isImperial = !!get(record, 'weightOz');

  const weightString = useMemo(() => {
    if (isOldShipment) {
      return `${get(record, 'weight.lb')} lb, ${get(record, 'weight.oz')} oz`;
    }
    if (isImperial) {
      const { weightLb, weightOz } = convertOzToLbOz(get(record, 'weightOz'));
      return `${weightLb} lb ${weightOz} oz`;
    }
    const { weightKg, weightGm } = convertGmToKgGm(get(record, 'weightGm'));
    return `${weightKg} kg ${weightGm} g`;
  }, [isImperial, isOldShipment, record]);

  return (
    <Grid container>
      <Grid item xs={6} className={classes.params}>
        <Dimensions className={classes.icon} />
        {get(record, 'size.width')}&times;{get(record, 'size.height')}&times;
        {get(record, 'size.length')} {isImperial || isOldShipment ? 'in' : 'cm'}
      </Grid>
      <Grid item xs={6} className={classes.params}>
        <Weight className={classes.icon} />
        {weightString}
      </Grid>
    </Grid>
  );
};

export default PackageField;
